import { addToRecord, updateRecord } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { UserFollowedByLoadPendingAction } from '../../domains/userFollowedBy/actions.types';
import {
  UserInsightsInfluenceLoadAction,
  UserInsightsInfluenceLoadFulfilledAction,
} from '../../domains/userInsightsInfluences/actions.types';
import { User } from '../users/types';

import { UserFollowedByMutual, UsersFollowedByMutual } from './types';

const initialState: UsersFollowedByMutual = {};

const initialUserFollowedByMutual: UserFollowedByMutual = {
  id: '',
  followedByMutual: [],
  cursor: null,
  hasNextPage: false,
  totalCount: 0,
  status: 'notRequested',
};

const stateWithPendingFollowedByMutual = (
  state: UsersFollowedByMutual,
  { id, isInitialLoad }: UserFollowedByLoadPendingAction['payload']
): UsersFollowedByMutual => {
  const followedBy = isInitialLoad ? initialUserFollowedByMutual : state[id];

  return addToRecord(state, id, { ...followedBy, status: 'pending' });
};

const stateWithFulfilledFollowedByMutual = (
  state: UsersFollowedByMutual,
  { id, entities, isInitialLoad }: UserInsightsInfluenceLoadFulfilledAction['payload']
): UsersFollowedByMutual => {
  const { cursor, hasNextPage, totalCount, followedByMutual: newFollowedByMutual } = entities.followedByMutual[id];
  const followedByMutual = isInitialLoad
    ? newFollowedByMutual
    : [...state[id].followedByMutual, ...newFollowedByMutual];

  const fulfilledFollowedByMutual: UserFollowedByMutual = {
    id,
    followedByMutual: [...new Set(followedByMutual)],
    cursor,
    hasNextPage,
    totalCount,
    status: 'fulfilled',
  };

  return addToRecord(state, id, fulfilledFollowedByMutual);
};

const stateWithRejectedFollowedByMutual = (state: UsersFollowedByMutual, id: User['id']): UsersFollowedByMutual =>
  updateRecord(state, id, { status: 'rejected' });

const reducer: Reducer<UsersFollowedByMutual, UserInsightsInfluenceLoadAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'USER_INSIGHTS_INFLUENCE.LOAD_PENDING':
      return stateWithPendingFollowedByMutual(state, action.payload);
    case 'USER_INSIGHTS_INFLUENCE.LOAD_FULFILLED':
      return stateWithFulfilledFollowedByMutual(state, action.payload);
    case 'USER_INSIGHTS_INFLUENCE.LOAD_REJECTED':
      return stateWithRejectedFollowedByMutual(state, action.payload.id);
    default:
      return state;
  }
};

export default reducer;
